/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S3_TitleInputs */

const en_guide_json_rest_api_s3_title = /** @type {(inputs: Guide_Json_Rest_Api_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common API Response Patterns`)
};

const ko_guide_json_rest_api_s3_title = /** @type {(inputs: Guide_Json_Rest_Api_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`일반적인 API 응답 패턴`)
};

const ja_guide_json_rest_api_s3_title = /** @type {(inputs: Guide_Json_Rest_Api_S3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的なAPIレスポンスパターン`)
};

/**
* | output |
* | --- |
* | "Common API Response Patterns" |
*
* @param {Guide_Json_Rest_Api_S3_TitleInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s3_title = /** @type {((inputs?: Guide_Json_Rest_Api_S3_TitleInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S3_TitleInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s3_title(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s3_title(inputs)
	return ja_guide_json_rest_api_s3_title(inputs)
});